import Swiper from "swiper";
import {Pagination} from "swiper/modules";
// import "swiper/swiper-bundle.css";

window.addEventListener("load", () => {
  const numbersWaveSlider = [...document.querySelectorAll('.section-numbers-wave')];
  let swiperInstances = [];

  const resetAllSlidesOpacity = (swiper) => {
    if (!swiper || !swiper.el) return;
    const allSlides = swiper.el.querySelectorAll('.swiper-slide');
    allSlides.forEach(slide => {
      slide.style.opacity = '';
    });
  };

  const setPrevSlidesOpacityZero = (swiper) => {
    if (!swiper || !swiper.el) return;
    const prevSlides = swiper.el.querySelectorAll('.swiper-slide-prev');
    prevSlides.forEach(slide => {
      slide.style.opacity = '0';
    });
  };

  const initSlider = (slider) => {
    if (!slider) return;

    const sliderInit = slider.querySelector('.swiper');
    if (!sliderInit) return;

    const mainSettings = {
      modules: [Pagination],
      speed: 500,
      spaceBetween: 0,
      slidesPerView: 2,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      on: {
        init: (swiper) => {
          resetAllSlidesOpacity(swiper);
          setPrevSlidesOpacityZero(swiper);
          swiper.el.style.overflow = 'visible';
        },
        touchStart: (swiper) => {
          resetAllSlidesOpacity(swiper);
        },
        sliderMove: (swiper) => {
          resetAllSlidesOpacity(swiper);
        },
        touchMove: (swiper) => {
          resetAllSlidesOpacity(swiper);
        },
        transitionStart: (swiper) => {
          resetAllSlidesOpacity(swiper);
        },
        touchEnd: (swiper) => {
          setPrevSlidesOpacityZero(swiper);
        },
        transitionEnd: (swiper) => {
          setPrevSlidesOpacityZero(swiper);
        },
        update: (swiper) => {
          swiper.el.style.overflow = 'visible';
        },
        resize: (swiper) => {
          swiper.el.style.overflow = 'visible';
        },
      },
    }

    const breakpoints = {768: {slidesPerView: 'auto'}};

    return new Swiper(sliderInit, {
      ...mainSettings,
      breakpoints: breakpoints,
    });
  };

  const destroySlider = (swiper) => {
    if (swiper) {
      resetAllSlidesOpacity(swiper);
      if (swiper.el && swiper.el.style) {
        swiper.el.style.overflow = '';
      }
      if (swiper.destroy) {
        swiper.destroy(true, true);
      }
    }
  };

  const handleResize = () => {
    const isMobile = window.innerWidth < 768;

    numbersWaveSlider.forEach((slider, index) => {
      const swiperInstance = swiperInstances[index];

      if (isMobile && !swiperInstance) {
        // Initialize slider on mobile
        swiperInstances[index] = initSlider(slider);
      } else if (!isMobile && swiperInstance) {
        // Destroy slider on desktop
        destroySlider(swiperInstance);
        swiperInstances[index] = null;
      }
    });
  };

  handleResize();
  window.addEventListener('resize', handleResize);
});
